// @ts-nocheck
import React from 'react';

/* A React component to handle countdowns */

interface TProps {
  children: (data: { isComplete: boolean; secondsLeft: number }) => React.ReactNode;
  onComplete?: () => void;
  onTick?: (data: { secondsLeft: number }) => void;
  minus: number;
}

interface TState {
  isComplete: boolean;
  secondsLeft: number;
}

export default class T extends React.Component<TProps, TState> {
  static defaultProps = {
    onComplete: null,
    onTick: null,
  };

  _endTime: number;
  _interval: NodeJS.Timeout | null = null;

  constructor(props: TProps) {
    super(props);
    this._endTime = Date.now() + props.minus * 1000;
    this.state = {
      isComplete: false,
      secondsLeft: props.minus,
    };
  }

  componentDidMount = () => {
    const { onTick } = this.props;
    const { secondsLeft } = this.state;
    onTick && onTick({ secondsLeft });
    this._interval = setInterval(this.handleTick, 1000);
  };

  componentWillUnmount = () => clearInterval(this._interval);

  handleTick = () => {
    const { onComplete, onTick } = this.props;
    const secondsLeft = Math.max(0, Math.round((this._endTime - Date.now()) / 1000));

    this.setState({ secondsLeft }, () => {
      onTick && onTick({ secondsLeft });
      if (secondsLeft === 0) {
        onComplete && onComplete();
        this.setState({ isComplete: true });
        clearInterval(this._interval);
      }
    });
  };

  render = () => {
    const { children } = this.props;
    const { isComplete, secondsLeft } = this.state;
    return children({ isComplete, secondsLeft });
  };
}
